import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  ContextualMenu,
  showHideMenu,
  hideWhenClickAwayOrResize,
  forceCloseContextualMenu,
} from '../../../shared/contextualMenu/content';
import {
  clickedJoinMeetingRoom,
  updateMeetingRoomForm,
  createVidyoRoomAuthTicket,
} from '../../../../actions/meetingRoom.js';
import { displayGlobalMessage } from 'actions/globalMessage';
import { insertAuthTicket, deleteAuthTicket } from '../view-all/centerPanel';

export default function ViewAllCenterPanel(props) {
  const dispatch = useDispatch();
  const [fetchingAuthTicket, setFetchingAuthTicket] = useState(false);
  const [authTicketArray, setAuthTicketArray] = useState([]);

  useEffect(() => {
    window.addEventListener('click', (event) => hideWhenClickAwayOrResize('.meeting-room-recent-calls', event));
    window.addEventListener('resize', (event) => hideWhenClickAwayOrResize('.meeting-room-recent-calls', event));

    return () => {
      window.removeEventListener('click', (event) => hideWhenClickAwayOrResize('.meeting-room-recent-calls', event));
      window.removeEventListener('resize', (event) => hideWhenClickAwayOrResize('.meeting-room-recent-calls', event));
    };
  }, []);

  const copyInvitationLinkToClipboard = (roomId) => {
    let callback = (meetingRoom) => {
      var clipboard = new window.Clipboard('.copy-to-clipboard-button-in-qv', {
        text: () => {
          return meetingRoom.roomUrl;
        },
      });
    };
    //CHECKING if data is already loaded or not
    let meetingRoom = props.quickViewMeetingRooms.find((x) => x.id == roomId);
    if (meetingRoom) {
      dispatch(updateMeetingRoomForm(meetingRoom));
      callback(meetingRoom);
    }
  };

  const showCopyLinkToClipboardGlobalMessage = (meetingRoomName) => {
    var successMessage = APP.LANGUAGE.CopyLinkToClipboard.SuccessfulMessage.replace('##meetingRoom##', meetingRoomName);
    dispatch(
      displayGlobalMessage({
        text: successMessage,
        visible: true,
        messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
        autoHide: true,
      })
    );
    //forceClose the contextual-menu
    setTimeout(() => {
      forceCloseContextualMenu('.row.flexible.row-hoverable.active');
    }, 200);
  };

  const joinMeetingRoom = (roomId) => {
    let meetingRoomUserWantsToJoin = authTicketArray.find((x) => x.meetingRoomId == roomId);
    dispatch(clickedJoinMeetingRoom(roomId));
    window.open(
      window.APP.CONFIGURATION.CALLSCREEN_LOCATION + '#/?authticket=' + meetingRoomUserWantsToJoin.callScreenAuthTicket,
      null,
      'width=' + (screen.width - 20) + ',height=' + (screen.height - 100) + ', left=0, top=0, scrollbars=yes,status=yes'
    );
    // Delete auth ticket
    let array = [...authTicketArray];
    let newArray = deleteAuthTicket(roomId, array);
    setAuthTicketArray(newArray);
    //forceClose the contextual-menu
    setTimeout(() => {
      forceCloseContextualMenu('.row.flexible.row-hoverable.active');
    }, 200);
  };

  let rendermeetingRooms = () => {
    let resultFound = props.quickViewMeetingRooms.find((x) => x.isUserInCall == true);

    let isUserInAnyCall = resultFound || props.isInCall ? true : false;

    //if there are recent calls
    return props.quickViewMeetingRooms.map((room, i) => {
      let dynamicId = room.id;

      //Writing PArticipants logic
      let participants = '';
      if (room.participants.length > 0) {
        participants = (
          <div className="color-gray pdtnull  color-selected-gray arrow">
            {room.participants.map((o, i) => {
              const guest = o.isGuestCaller ? ' (' + APP.LANGUAGE.MeetingRoomPersonStatus.Guest + ')' : '';

              //SHOWING PARTICIPANTS ON THE CONTEXT MENU
              return (
                <div key={i + o.name} className="borderless pdtxs mrlxxs color-selected-gray arrow">
                  <i className=" blue user icon text-size-s   arrow " />
                  <span className="mrlxxs text-size-mms color-selected-gray" style={{ lineHeight: '1.4rem' }}>
                    {o.name + guest}
                  </span>
                </div>
              );
            })}
          </div>
        );
      } else {
        //if there are no participant in this meeting room
        participants = (
          <div className="ui  max-width  borderless pdtxxs color-selected-gray arrow">
            <span className="text color-gray color-selected-gray text-size-mms arrow">
              {APP.LANGUAGE.QuickViewMeetingRoom.NoParticipantsMessage}
            </span>
          </div>
        );
      }

      let JoinTitle = fetchingAuthTicket ? (
        <div className="color-placeholder">
          {APP.LANGUAGE.ViewMeetingRoom.JoinAction}
          <i className="ui icon spinner loading mrlxxs" />
        </div>
      ) : (
        <div>
          {APP.LANGUAGE.QuickViewMeetingRoom.JoinAction} <i className="teal sign in icon mrlxxs" />
        </div>
      );

      //CONTEXT MENU LOGIC
      let contextualMenu = (
        <ContextualMenu
          id={dynamicId}
          renderChildLast={true}
          options={[
            {
              title: JoinTitle,
              customAction: true,
              isFetching: false,
              show: !isUserInAnyCall,
              active: true,
              action: () => {
                joinMeetingRoom(room.id);
              },
              fieldClass: fetchingAuthTicket ? 'disable-msg text-size-mms' : 'text-size-mms',
            },
            {
              title: APP.LANGUAGE.QuickViewMeetingRoom.JoinAction,
              customAction: true,
              isFetching: false,
              show: isUserInAnyCall,
              active: false,
              iconClassName: 'color-bad-things-text ban icon text-size-m ',
              fieldClass: 'text-size-mms disable',
            },
            {
              title: APP.LANGUAGE.QuickViewMeetingRoom.CopyLink,
              customAction: true,
              isFetching: false,
              active: true,
              action: () => {
                showCopyLinkToClipboardGlobalMessage(room.name);
              },
              fieldClass: 'text-size-mms copy-to-clipboard-button-in-qv',
            },
          ]}
        >
          {/*//The child : it will be rendered as it is in context Menu. shows the list of participants*/}
          <div className="ui  max-width pdnull mrtxs color-selected-gray arrow pdtnull">
            <div className=" borderless  pdtnull mrtnull color-selected-gray arrow">
              <span className="text-size-mms color-selected-gray arrow">
                {APP.LANGUAGE.QuickViewMeetingRoom.InRoomAction}
              </span>
            </div>
            {participants}
          </div>
        </ContextualMenu>
      );

      let applyBorder = ' quickViewBorder';
      if (room.id == props.quickViewMeetingRooms[props.quickViewMeetingRooms.length - 1].id) {
        applyBorder = '';
      }

      let participantsIcon = '';
      if (room.participants.length > 0) {
        participantsIcon = <i className="mrlxs pdtm icon color-meeting-room users text-size-ml" />;
      } else {
        participantsIcon = <i className="mrlxs pdtm icon color-neutral-center-gray users  text-size-ml" />;
      }

      return (
        <div
          className={
            'row flexible row-hoverable center aligned color-black center-aligned meetingRoomRowsPadding' + applyBorder
          }
          key={room.id}
          onClick={(event) => {
            let container = document.getElementsByClassName('quick-view-modal')[0];

            showHideMenu(
              null,
              '.meeting-room-recent-calls',
              dynamicId,
              event.target,
              event.currentTarget,
              122,
              container
            );
            copyInvitationLinkToClipboard(room.id);
            // Generate auth ticket && contextual menu is opened
            if (!authTicketArray || (authTicketArray && !authTicketArray.some((x) => x.meetingRoomId === room.id))) {
              setFetchingAuthTicket(true);
              var cbGetAuthTicket = (result, callScreenAuthTicket) => {
                if (!result) {
                  console.error('No Auth Ticket was created');
                  return;
                }
                let array = [...authTicketArray];
                let newArray = insertAuthTicket(room.id, callScreenAuthTicket, array);
                setAuthTicketArray(newArray);
                setFetchingAuthTicket(false);
              };
              dispatch(createVidyoRoomAuthTicket(room.id, cbGetAuthTicket));
            }
          }}
        >
          {contextualMenu}
          {participantsIcon}
          <div className="left-column-fixed left-text column  pdlxs pdtxs pdbxs ">
            <div className="ellipsis" style={{ lineHeight: '25px', marginTop: '2px' }}>
              {room.name}
            </div>
            <div className="mobileSecondRow ellipsis text-size-ms" style={{ marginBottom: '2px' }}>
              ({room.organisationAbbreviatedName})
            </div>
          </div>
        </div>
      );
    });
  };

  let meetingRooms = () => {
    var showContent = !props.fetching || (props.quickViewMeetingRooms && props.quickViewMeetingRooms.length > 0);

    if (showContent) {
      return rendermeetingRooms();
    } else {
      return (
        <div className="row mrts noscroll border-bottom-null flexible row-hoverable row-loading">
          <div className="left-column-fixed left-text column bold mrls color-gray color-gray-bg pdnull  pdtnull mrrxl mrlxl" />
          <div className="ui active inverted dimmer">
            <div className="ui text loader mrtxs " />
          </div>
        </div>
      );
    }
  };

  return (
    <div>
      <div className="ui equal width center aligned padded grid">{meetingRooms()}</div>
    </div>
  );
}
